import * as React from 'react';
import getScenarioStore from '../../selectors/getScenarioStore';
import SearchSuggestion from './searchSuggestion/SearchSuggestion';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib/Icon';
import { SettingSuggestion } from 'owa-search-service/lib/data/schema/SuggestionSet';
import { observer } from 'mobx-react-lite';
import { SearchScenarioId } from '../../store/schema/SearchScenarioId';
import getHighlightedTextForSuggestion from '../../utils/getHighlightedTextForSuggestion';
import highlightDisplayTextWithQuery from '../../utils/highlightDisplayTextWithQuery';

const searchSuggestionStyles = require('./searchSuggestion/SearchSuggestion.scss');
const styles = require('./eventSearchSuggestion/EventSearchSuggestion.scss');

export interface SettingSearchSuggestionProps {
    index: number;
    scenarioId: SearchScenarioId;
    suggestion: SettingSuggestion;
    suggestionSetTraceId: string;
}

const SettingSearchSuggestion = observer(function SettingSearchSuggestion(
    props: SettingSearchSuggestionProps
) {
    const { index, scenarioId, suggestion, suggestionSetTraceId } = props;

    const hitHighlightedDisplayText = highlightDisplayTextWithQuery(
        suggestion.SettingName,
        getScenarioStore(scenarioId).searchTextForSuggestion
    );

    return (
        <SearchSuggestion
            ariaLabel={suggestion.SettingName}
            content={
                <div className={styles.container}>
                    <Icon
                        className={searchSuggestionStyles.icon}
                        iconName={ControlIcons.Settings}
                    />
                    <div className={styles.eventContentContainer}>
                        <div className={styles.eventSubject}>
                            {getHighlightedTextForSuggestion(hitHighlightedDisplayText)}
                        </div>
                        <div className={styles.secondaryText}>
                            <span>{suggestion.SettingDescription}</span>
                        </div>
                    </div>
                </div>
            }
            suggestion={suggestion}
            scenarioId={scenarioId}
            suggestionSetTraceId={suggestionSetTraceId}
            index={index}
        />
    );
});

export default SettingSearchSuggestion;
